import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      token:"",
      tabFlag:true,
      loginFlag:false,
  },
  mutations: {
    addToken(state,token){
      return state.token=token;
    },

      setTabFlag(state,value){
          state.tabFlag = value
      },

      setLoginFlag(state,value){
          state.loginFlag = value
      }
  },
  actions: {
  },
  modules: {
  }
})
